import { baseUniDriverFactory } from '../utils/test-utils/unidriver';

import { dataHooks } from './constants';

export const sidebarHeaderNextDriverFactory = base => {
  return {
    ...baseUniDriverFactory(base),

    getTitle: () => base.$(`[data-hook="${dataHooks.title}"]`).text(),
    getSubtitle: () => base.$(`[data-hook="${dataHooks.subtitle}"]`).text(),
    getSkin: () => base.attr('data-skin'),
  };
};
